// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgGridMasonry2 = ({color = 'currentColor', size = 20}: IconProps) => (
  <svg
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    height={size}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.75 2A2.75 2.75 0 0 0 2 4.75v10.5A2.75 2.75 0 0 0 4.75 18h10.5A2.75 2.75 0 0 0 18 15.25V4.75A2.75 2.75 0 0 0 15.25 2H4.75ZM3.5 4.75c0-.69.56-1.25 1.25-1.25H9V11H3.5V4.75Zm0 7.75H9v4H4.75c-.69 0-1.25-.56-1.25-1.25V12.5Zm7 4h4.75c.69 0 1.25-.56 1.25-1.25V9.5h-6v7Zm0-8.5V3.5h4.75c.69 0 1.25.56 1.25 1.25V8h-6Z"
    />
  </svg>
)

export default SvgGridMasonry2
